import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    mb: 1,
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'grey.800',
  },
  filterContainer: { display: 'flex', alignItems: 'center' },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
